import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StContainer = styled.div<{ reviewed?: boolean }>`
  display: flex;
  flex-direction: column;
  cursor: pointer;

  ${({ theme, reviewed }) => `
    gap: ${theme.UI.SpacingPx.Space4};
    padding: ${theme.UI.SpacingPx.Space5} ${theme.UI.SpacingPx.Space4};
    background-color: ${reviewed ? `${theme.Colors.Status.Success}0D` : theme.Colors.Neutrals.Lightest};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    border: 1px solid ${reviewed ? theme.Colors.Status.Success : theme.Components.Card.Border};
  `}

  @media ${breakpoints.s} {
    border-width: 2px;
  }
`

export { StContainer }
